"use client";
import React from "react";
import { useEffect } from "react";
import client from "./../../client";
import { useState } from "react";
import { PortableText } from "@portabletext/react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import SlugHeader from "./SlugHeader";
import BlogSideBar from "../Blog/BlogSideBar/BlogSideBar";
import "./../Blog/Blog.css";
import OurServices from "../HomePage/OurServices/OurServices";
import Benefits from "../Benefits/Benefits";
import Review from "../Review/Review";
import { portableTextComponents } from "../PortableTextComponents";
import SanitySeoKeywords from "./SanitySeoKeyword";
import BlogAuthor from "./../Blog/BlogAuthor/BlogAuthor";

function isValidBlocks(blocks) {
  return (
    Array.isArray(blocks) &&
    blocks.length > 0 &&
    typeof blocks[0] === "object" &&
    blocks[0]._type
  );
}

const SlugPage = () => {
  const { slug } = useParams();
  const [blogPost, setBlogPost] = useState(null);
  const [servicePage, setServicePage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;

    setIsLoading(true);

    client
      .fetch(
        `{
          "post": *[_type == "post" && slug.current == $slug][0]{
            title,
            body,
            mainImage{
              asset->{_id,url},
              alt
            },
            source {
              text,
              url
            }
          },

          "serviceCategory": *[_type == "ServiceCategory" && slug.current == $slug][0]{
            title,
            mainImage {
              asset->{_id, url},
              alt
            },
            body1,
            body2,
            metaTitle,
            metaDescription,
                seoKeywords{
  keywords
},
          }
        }`,
        { slug },
      )
      .then((data) => {
        console.log("Sanity fetch full data:", data);
        setBlogPost(data.post || null);
        setServicePage(data.serviceCategory || null);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Sanity fetch error:", err);
        setIsLoading(false);
      });
  }, [slug]);

  if (isLoading) return <h1>Loading...</h1>;
  if (!blogPost && !servicePage) return <h1>No content found.</h1>;

  return (
    <div className="slug-container">
      <Helmet>
        <title>{blogPost?.title || servicePage?.title}</title>
        <meta
          name="description"
          content={blogPost?.title || servicePage?.title}
        />
        <link rel="canonical" href={`https://goodway-attestation.com/${slug}`} />
      </Helmet>

      {blogPost && (
        <>
          <div className="blog-wrapper1">
            {blogPost.mainImage?.asset?.url && (
              <img
                src={blogPost.mainImage.asset.url}
                alt={blogPost.mainImage.alt || blogPost.title}
                className="blog__image rounded-t"
              />
            )}
            <div className="slugService-content">
              <h1>{blogPost.title}</h1>
              {isValidBlocks(blogPost.body) ? (
                <>
                  <PortableText
                    value={blogPost.body}
                    components={portableTextComponents}
                  />
                  {blogPost.source?.url && blogPost.source?.text && (
                    <p className="source-link">
                      Source:{" "}
                      <a
                        href={blogPost.source.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {blogPost.source.text}
                      </a>
                    </p>
                  )}
                  <BlogAuthor />
                </>
              ) : (
                <p>No valid content to display.</p>
              )}
            </div>
          </div>
          <div className="blog-wrapper2">
            <BlogSideBar />
          </div>
        </>
      )}

      {servicePage && (
        <div className="slugService-container">
          {servicePage.mainImage?.asset?.url && (
            <SlugHeader
              img={servicePage.mainImage.asset.url}
              headTitle={servicePage.title}
            />
          )}
          <div className="slugService-content">
            <h1>{servicePage.title}</h1>
            {isValidBlocks(servicePage.body1) && (
              <>
                <PortableText
                  value={servicePage.body1}
                  components={portableTextComponents}
                />
              </>
            )}
          </div>
          {/* <HomeLink /> */}
          {/* <HomeMarquee /> */}
          <OurServices />
          <Benefits />
          <Review />
          {/* <Faq /> */}
          {servicePage?.seoKeywords?.keywords?.length > 0 && (
            <SanitySeoKeywords keywords={servicePage.seoKeywords.keywords} />
          )}
          <div className="slugService-content">
            {isValidBlocks(servicePage.body2) && (
              <PortableText
                value={servicePage.body2}
                components={portableTextComponents}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SlugPage;
